export default __webpack_public_path__ + "static/media/header.7ce0c545.png";